<div class="appContentsContainer">
  <div
    id="mantenimientoContainer"
    class="backgroundSand container fullWidthContainer listPage"
  >
    <h2>{{ "templates.titleList" | translate }}</h2>
    <div class="filterTableContainer">
      <app-filters
        #insideTable
        [filterList]="filterList"
        (valueFilter)="filterSearch($event)"
        [options]="options"
        [ngClass]="{ filterHidden: !showTableFilter }"
        (showFilters)="showFilters($event)"
      ></app-filters>
      <app-table
        [tableList]="tableList"
        [elementList]="templates"
        [routing]="routing"
        [numPages]="numPages"
        [numElements]="numElements"
        [totalElements]="totalElements"
        [filterParams]="filtersTableJSON"
        [options]="options"
        [showFilterButtons]="showFilterButtons"
        (valueFilterTable)="filterTable($event)"
        (elementsToRemove)="removeElements($event)"
        (headerButtonsActionEvent)="buttonsHeader($event)"
      ></app-table>
      <div class="backButton">
        <button
          class="formButtonBack"
          type="button"
          (click)="goPredefinedMailBox()"
        >
          <em class="fas fa-times fa-2x backButtonAlign"></em>
        </button>
      </div>
    </div>
  </div>
</div>
